import { combineReducers } from "@reduxjs/toolkit";

import {
	globalStateCarSectorsDataState,
	globalStateCarSectorsDataReducer,
	globalStateCarSectorsDataAction,
} from "./data";

export type StateCarSectors = {
	data: globalStateCarSectorsDataState;
};

export const carSectors = combineReducers<StateCarSectors>({
	data: globalStateCarSectorsDataReducer,
});

export const globalStateCarSectorsAction = {
	data: globalStateCarSectorsDataAction,
};

export default carSectors;
